<template>
  <div>
    <v-card>
      <v-form ref="form" lazy-validation>
        <v-card-title>
          <span>Change Password</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-0 pt-0">
                <v-text-field
                  :append-icon="
                    show.currentPassword ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  label="Current Password*"
                  :type="show.currentPassword ? 'text' : 'password'"
                  v-model="form.currentPassword"
                  :rules="rules.required"
                  @click:append="show.currentPassword = !show.currentPassword"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-0 pt-0">
                <v-text-field
                  :append-icon="show.newPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="New Password*"
                  :type="show.newPassword ? 'text' : 'password'"
                  v-model="form.newPassword"
                  :rules="rules.required"
                  @click:append="show.newPassword = !show.newPassword"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-0 pt-0">
                <v-text-field
                  :append-icon="
                    show.confirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  label="Confirm Password*"
                  :type="show.confirmPassword ? 'text' : 'password'"
                  v-model="form.retypePassword"
                  :rules="rules.required"
                  @click:append="show.confirmPassword = !show.confirmPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isChangePasswordPage"
            :disabled="loadingBtn"
            @click="closeDialog()"
          >
            Close
          </v-btn>

          <v-btn v-else :disabled="loadingBtn" @click="logout()">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="loadingBtn"
            :disabled="loadingBtn"
            @click="onSubmit()"
            class="px-10"
          >
            Submit
            <!-- Submit You are required to re-login using your new password. -->
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <Snackbar></Snackbar>
    <ConfirmationDiaglog ref="confirm"></ConfirmationDiaglog>
  </div>
</template>

<script>
import Snackbar from "../views/dialogs/Snackbar.vue";
import ConfirmationDiaglog from "../views/dialogs/ConfirmationDiaglogv2.vue";

export default {
  name: "ChangePasswordForm",
  components: {
    Snackbar,
    ConfirmationDiaglog,
  },

  data() {
    return {
      loadingBtn: false,
      show: {
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
      },
      form: {
        currentPassword: "",
        newPassword: "",
        retypePassword: "",
      },
      rules: {
        required: [(value) => !!value || "Required."],
      },
    };
  },

  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to proceed?"
        )
      ) {
        const { adminLogin, token } = this.$store.getters.userData;
        let data = this.form;
        data._id = adminLogin._id;

        this.loadingBtn = true;
        await this.$api
          .post("/change-password", data, {
            headers: {
              "wsc-token": token,
            },
          })
          .then((response) => {
            // console.log(response);
            this.loadingBtn = false;
            const res = response.data;

            // if (!res.status) {
            //   // this.snachbar.message = res.message;
            //   this.$store.dispatch("addSnackbarMessage", res.message);
            //   this.$store.dispatch("addSnackbar", true);
            //   return;
            // }

            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);

            if (res.status) {
              this.$refs.form.reset();
              this.$store.dispatch("set_force_password").then(() => {
                // this.$router.push("/");
                this.logout();
              });
            }
          })
          .catch((e) => {
            // this.$emit("response", {
            //   status: false,
            //   message: e,
            // });
            this.$store.dispatch("addSnackbarMessage", e);
            this.$store.dispatch("addSnackbar", true);
            this.loadingBtn = false;
          });
      }
    },

    closeDialog() {
      this.$refs.form.reset();
      this.$emit("close", true);
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$store.dispatch("addDashboardRole", {});
        this.$router.push("/");
      });
    },

    async confirmDialog() {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to proceed?"
        )
      ) {
        this.onSubmit();
        return;
      }

      // this.loadingBtn = false;
    },
  },

  computed: {
    isChangePasswordPage() {
      if (this.$route.path === "/change-password") {
        return true;
      }
      return false;
    },
  },
};
</script>
